const PreviewTableTwo = ({ tertiary}) => {
    
    return ( 
        <table className="mt-2">
            <thead>
                <tr>
                    <th>Level Attained</th>
                    <th>Course Title</th>
                    <th>Year Obtained</th>
                </tr>
                </thead>
                <tbody>
                    {
                        tertiary && tertiary.map(record => (
                            <tr key={ record.course}>
                                <td>{ record.tertiaryLevel }</td>
                                <td>{ record.course }</td>    
                                <td>{ record.tertiaryYear }</td>    
                            </tr>
                        ))
                    }             
            </tbody>
        </table>
     );
}
 
export default PreviewTableTwo;